import { LegalLayout, LegalH2, LegalP, LegalList, PH } from "@/components/landing/LegalLayout";

export default function TerminiVendita() {
  return (
    <LegalLayout title="Termini e Condizioni di Vendita" updated="Ottobre 2026" testid="termini-page">
      <LegalH2>1. Venditore</LegalH2>
      <LegalP>
        Il presente sito e il servizio MIR-IA sono gestiti da <strong>MIRLO'S COMPANY LLC</strong>, con sede in
        Shams Media City, Al Mtsannid Suburb, Sharjah (UAE), License n. 2541494, Tax Registration Number
        105310671000001, email <a href="mailto:info@miria.one" className="font-semibold text-purple-700 underline underline-offset-2">info@miria.one</a> (di seguito "il Venditore").
      </LegalP>

      <LegalH2>2. Definizioni</LegalH2>
      <LegalList
        items={[
          "Servizio: l'abbonamento annuale MIR-IA Starter Pack e tutte le prestazioni incluse;",
          "Cliente: il libero professionista o la piccola attività che acquista il Servizio;",
          "Piattaforma: l'area online MIR-IA con assistente AI Mirlo IA, bacheca contenuti e guide;",
          "Contenuti: grafiche, testi, idee, foto e materiali prodotti nell'ambito del Servizio.",
        ]}
      />

      <LegalH2>3. Oggetto del contratto</LegalH2>
      <LegalP>
        Il contratto ha per oggetto l'abbonamento annuale "MIR-IA Starter Pack" al prezzo di 997€/anno (oltre IVA
        o imposte locali dove applicabili), che comprende per 365 giorni:
      </LegalP>
      <LegalList
        items={[
          "1 shooting fotografico dedicato alla tua attività, concordato su data e location;",
          "3 contenuti pronti da postare ogni mese: grafiche, descrizioni e hashtag personalizzati;",
          "10 idee di contenuto extra da realizzare ogni mese;",
          "accesso all'assistente AI Mirlo IA, con 30 generazioni al mese;",
          "guide pratiche sull'utilizzo dei social partendo da zero e guida alla creazione di campagne ADS;",
          "accesso alla bacheca contenuti e al calendario editoriale della Piattaforma.",
        ]}
      />

      <LegalH2>4. Prezzo e pagamento</LegalH2>
      <LegalP>
        Il prezzo indicato al checkout è quello dovuto e viene pagato in un'unica soluzione tramite Stripe, con
        carta di credito/debito o gli altri metodi disponibili. Le eventuali imposte applicabili sono calcolate e
        mostrate prima della conferma. La fattura viene emessa secondo i dati di fatturazione inseriti al
        pagamento.
      </LegalP>

      <LegalH2>5. Conclusione del contratto</LegalH2>
      <LegalP>
        Il contratto si intende concluso al momento della conferma del pagamento, che ti viene comunicata via
        email insieme alle istruzioni di attivazione. Procedendo al pagamento dichiari di aver letto e accettato
        integralmente i presenti Termini e la Privacy Policy.
      </LegalP>

      <LegalH2>6. Durata, attivazione e rinnovo</LegalH2>
      <LegalP>
        L'abbonamento dura 365 giorni dalla data di attivazione e non si rinnova automaticamente. Alla scadenza
        potrai decidere liberamente se riattivarlo al prezzo vigente in quel momento. Lo shooting fotografico
        viene pianificato insieme a te dopo l'acquisto, in base alla disponibilità di date e location; i contenuti
        mensili sono resi disponibili sulla Piattaforma secondo il calendario editoriale condiviso.
      </LegalP>

      <LegalH2>7. Diritto di recesso e rimborsi</LegalH2>
      <LegalP>
        <strong>Acquisti effettuati da professionisti (con partita IVA):</strong> l'acquisto è definitivo: non
        sono previsti diritto di recesso, ripensamento o rimborso, nemmeno parziale, salvo obblighi inderogabili
        di legge.
      </LegalP>
      <LegalP>
        <strong>Acquisti effettuati da consumatori:</strong> ai sensi del D.Lgs 206/2005 (Codice del Consumo)
        hai diritto di recedere dal contratto entro 14 giorni dall'acquisto, senza fornire alcuna motivazione,
        scrivendo a <a href="mailto:info@miria.one" className="font-semibold text-purple-700 underline underline-offset-2">info@miria.one</a>.
        Con il pagamento richiedi però espressamente che l'esecuzione del Servizio inizi subito: ai sensi
        dell'art. 58 del Codice del Consumo, in caso di recesso ti sarà dovuto solo l'importo proporzionale a
        quanto già erogato fino al momento del recesso (ad esempio lo shooting già effettuato); ai sensi
        dell'art. 59, lett. a), il diritto di recesso decade quando il Servizio sia stato integralmente eseguito
        con il tuo consenso espresso. Salvo quanto previsto dalla legge a tutela dei consumatori, non sono
        previsti rimborsi. Se hai dubbi prima di acquistare, scrivici: ti aiutiamo a capire se MIR-IA fa per te.
      </LegalP>

      <LegalH2>8. Obblighi del Cliente</LegalH2>
      <LegalList
        items={[
          "Fornire dati veritieri e completi in fase di acquisto e fatturazione;",
          "Fornire tempestivamente i materiali e le informazioni necessarie allo shooting e ai contenuti;",
          "Utilizzare la Piattaforma e i Contenuti solo per la propria attività, in modo lecito e senza violare diritti di terzi;",
          "Non rivendere, cedere o condividere l'accesso alla Piattaforma con terzi.",
        ]}
      />

      <LegalH2>9. Proprietà intellettuale</LegalH2>
      <LegalP>
        I Contenuti realizzati per te (foto dello shooting, grafiche, testi e idee) ti sono concessi in licenza
        d'uso illimitata per la promozione della tua attività, anche dopo la scadenza dell'abbonamento. Restano di
        proprietà del Venditore la Piattaforma, il marchio MIR-IA, l'assistente Mirlo IA, le guide e ogni altro
        materiale preesistente, che non possono essere copiati o riutilizzati fuori dal Servizio.
      </LegalP>

      <LegalH2>10. Limitazione di responsabilità</LegalH2>
      <LegalP>
        MIR-IA fornisce strumenti, contenuti e guide di marketing: i risultati commerciali dipendono da molti
        fattori esterni e non possono essere garantiti. Il Venditore non risponde di danni indiretti, mancato
        profitto o interruzioni dovute a terze parti (social network, provider di pagamento, connettività). Nulla
        in questi Termini limita i diritti irrinunciabili previsti dalla legge applicabile.
      </LegalP>

      <LegalH2>11. Sospensione e risoluzione</LegalH2>
      <LegalP>
        In caso di uso illecito della Piattaforma o violazione grave di questi Termini, il Venditore può
        sospendere o interrompere il Servizio con comunicazione via email, senza obbligo di rimborso. Il Cliente
        può interrompere l'utilizzo in qualsiasi momento; l'interruzione non dà diritto ad alcun rimborso.
      </LegalP>

      <LegalH2>12. Modifiche ai Termini</LegalH2>
      <LegalP>
        Il Venditore può aggiornare i presenti Termini; la versione applicabile al tuo abbonamento è quella in
        vigore al momento dell'acquisto, disponibile in questa pagina con la data di aggiornamento.
      </LegalP>

      <LegalH2>13. Privacy</LegalH2>
      <LegalP>
        Il trattamento dei tuoi dati personali è descritto nella Privacy Policy, parte integrante di questi
        Termini.
      </LegalP>

      <LegalH2>14. Legge applicabile e foro competente</LegalH2>
      <LegalP>
        Il contratto è regolato dalla legge italiana. Per i consumatori è competente il foro del luogo di
        residenza o domicilio del consumatore; per i professionisti, il foro di Sharjah (UAE), salvo diverso
        accordo tra le parti.
      </LegalP>

      <LegalH2>15. Reclami e risoluzione alternativa delle controversie</LegalH2>
      <LegalP>
        Per qualsiasi reclamo relativo al Servizio puoi scrivere a <a href="mailto:info@miria.one" className="font-semibold text-purple-700 underline underline-offset-2">info@miria.one</a>:
        risponderemo entro 14 giorni. Se sei un consumatore, resta ferma la facoltà di rivolgerti agli organismi
        di risoluzione alternativa delle controversie (ADR) previsti dal Codice del Consumo o alla mediazione,
        oltre naturalmente al giudice ordinario. Nulla di quanto contenuto nei presenti Termini limita i diritti
        irrinunciabili riconosciuti al consumatore dalla legge italiana e dell'Unione Europea.
      </LegalP>

      <LegalH2>16. Contatti</LegalH2>
      <LegalP>
        Per qualsiasi domanda sul Servizio o sui presenti Termini: <a href="mailto:info@miria.one" className="font-semibold text-purple-700 underline underline-offset-2">info@miria.one</a> — MIRLO'S COMPANY
        LLC, Shams Media City, Al Mtsannid Suburb, Sharjah (UAE).
      </LegalP>
    </LegalLayout>
  );
}
